/**
 * @method setAlertModal
 */
export function ModalController() {
    this.alertModal = null;
    this.loadingModal = null;
    this.confirmModal = null;
    this.otpModal = null;
    this.listGiftModal = null;
    this.scrollBodyModal = null;


    this.setAlertModal = function (alertModalController) {
        this.alertModal = alertModalController;
    };

    this.setLoadingModal = function (loadingModalController) {
        this.loadingModal = loadingModalController;
    };

    this.setConfirmModal = function (confirmModalController) {
        this.confirmModal = confirmModalController;
    };

    this.setOtpModal = function (otpModalController) {
        this.otpModal = otpModalController;
    };

    this.setListGiftModal = function (listGiftModalController) {
        this.listGiftModal = listGiftModalController;
    };

    this.setScrollBodyModal = function (scrollBodyModalController) {
        this.scrollBodyModal = scrollBodyModalController;
    };

}
